export type AudienceSummaryTab = "timeline" | "consolidated" | "themes";

export function selectVisibleAudienceConsolidation<T extends { sessionId: string }>(
  tab: AudienceSummaryTab,
  sessionId: string,
  liveConsolidation: T | null | undefined,
): T | null | undefined {
  if (tab === "timeline") return null;
  if (!liveConsolidation) return liveConsolidation;
  return liveConsolidation.sessionId === sessionId ? liveConsolidation : null;
}
